import { AuthService } from '../service/auth.service';
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthService) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        console.error('Error caught by interceptor:', err);

        let error = '';

        if (err.status === 0) {
          error = 'Network Error: Please check your connection';
        } else {
          error = this.extractErrorMessage(err.error);
        }

        if (!error) {
          if (err.status === 401) {
            // Optional: Handle token refresh or logout
            // this.authenticationService.logout();
            // location.reload();
            error = 'Session Expired';
          } else if (err.status === 404) {
            error = 'Server Not found';
          } else if (err.status === 0) {
            error = 'Network Error: Please check your connection';
          } else if (err.status === 403) {
            error = 'Unauthorized Request';
          } else if (err.status >= 500) {
            error = `Server Error (${err.status})`;
          } else if (err.status === 400) {
              error = 'Bad Request (400)';
          } else {
            error = err.statusText || err.message || 'Something Went Wrong';
          }
        }

        return throwError(error);
      })
    );
  }

  private extractErrorMessage(errorObj: any): string {
    if (!errorObj) return '';

    try {
      if (typeof Event !== 'undefined' && errorObj instanceof Event) {
        return '';
      }

      if (typeof ProgressEvent !== 'undefined' && errorObj instanceof ProgressEvent) {
        return '';
      }

      // If it's a string, try parsing it as JSON recursively
      if (typeof errorObj === 'string') {
        try {
          const parsed = JSON.parse(errorObj);
          return this.extractErrorMessage(parsed);
        } catch (e) {
          return errorObj;
        }
      }

      // 1. Handle ASP.NET Core 'errors' or 'Errors' object
      const errors = errorObj.errors || errorObj.Errors;
      if (errors) {
        if (typeof errors === 'string') return errors;
        const messages = [];
        for (const key in errors) {
          if (errors.hasOwnProperty(key)) {
            const val = errors[key];
            if (Array.isArray(val)) {
              messages.push(...val);
            } else if (typeof val === 'string') {
              messages.push(val);
            }
          }
        }
        if (messages.length > 0) return messages.join('\n');
      }

      // 2. Common message properties in priority order
      const msg = errorObj.Message || errorObj.message || errorObj.Error || errorObj.error || errorObj.errorMessage || errorObj.title;
      if (msg && typeof msg === 'string') return msg;
      
      // 3. Fallback for objects - stringify them to show something meaningful,
      // but skip browser event objects that only expose transport metadata.
      if (typeof errorObj === 'object') {
        if ('isTrusted' in errorObj && Object.keys(errorObj).length === 1) {
          return '';
        }
        return JSON.stringify(errorObj);
      }
    } catch (e) {
      console.error('Failed to extract error message', e);
    }
    return '';
  }
}
